<div class="privacy-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'sidebar.footer.links.privacy' | translate }}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <upsc-privacy></upsc-privacy>
    </mat-dialog-content>
</div>
